import Vue from 'vue'
import VueRouter from 'vue-router'

import NotFound from '@/pages/NotFound'

import ShopList from '@/app/special/pages/ShopList'
import Shop from '@/app/special/pages/Shop'
import Cars from '@/app/special/pages/Cars'
import Car from '@/app/special/pages/Car'
import Days from '@/app/special/pages/Days'
import BookPeriod from '@/app/special/pages/BookPeriod'
import BookOption from '@/app/special/pages/BookOption'
import BookRemark from '@/app/special/pages/BookRemark'
import BookConfirm from '@/app/special/pages/BookConfirm'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'shop-list',
    component: ShopList
  },
  {
    path: '/shops/:shopid',
    name: 'shop',
    component: Shop,
    props: true
  },
  {
    path: '/shops/:shopid/cars',
    name: 'cars',
    component: Cars,
    props: true
  },
  {
    path: '/shops/:shopid/cars/:carid',
    name: 'car',
    component: Car,
    props: true
  },
  {
    path: '/shops/:shopid/days',
    name: 'days',
    component: Days,
    props: true
  },
  {
    path: '/shops/:shopid/book/period',
    name: 'book-period',
    component: BookPeriod,
    props: true
  },
  {
    path: '/shops/:shopid/book/option',
    name: 'book-option',
    component: BookOption,
    props: true
  },
  {
    path: '/shops/:shopid/book/remark',
    name: 'book-remark',
    component: BookRemark,
    props: true
  },
  {
    path: '/shops/:shopid/book/confirm',
    name: 'book-confirm',
    component: BookConfirm,
    props: true
  },

  {
    path: '*',
    name: 'not-found',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL + 'special/',
  routes
})

export default router
